import { ExamActionTypes } from "./exam.types";

const INITAIL_STATE = {
  exam: null,
  isFetchingExam: false,
  errorFetchingExam: null,
  examDetails: null,
  isFetchingExamDetails: true,
  errorFetchingExamDetails: null,
  //exam template details
  examTemplateDetails: null,
  isFetchingExamTemplateDetails: true,
  errorFetchingExamTemplateDetails: null,
  //exam info
  examInfo: null,
  isFetchingExamInfo: true,
  errorFetchingExamInfo: null,
  //exam Template info
  examTemplateInfo: null,
  isFetchingExamTemplateInfo: true,
  errorFetchingExamTemplateInfo: null,
  //delete exam
  isFetchingDeleteExam: false,
  errorFetchingDeleteExam: null,
  //delete bank exam
  isFetchingDeleteBankExam: false,
  errorFetchingDeleteBankExam: null,
  //active exam
  isFetchingActiveExam: false,
  errorFetchingActiveExam: null,
  //active exam
  isFetchingPostQuestion: false,
  errorFetchingPostQuestion: null,
  //active template exam
  isFetchingPostTemplateQuestion: false,
  errorFetchingPostTemplateQuestion: null,
  //add exam
  data: null,
  isFetchingAddExam: false,
  errorFetchingAddExam: null,
  //add template exam
  templateData: null,
  isFetchingAddTemplateExam: false,
  errorFetchingAddTemplateExam: null,
  //exam list
  examsListData: [],
  examsListOffset: 0,
  examsListLoadMore: false,
  isFetchingExamsList: false,
  errorFetchingExamsList: null,
  //bank exam list
  bankExamsListdata: [],
  bankExamsListOffset: 1,
  bankExamsListLoadMore: false,
  isFetchingBankExamsList: false,
  errorFetchingBankExamsList: null,
  //student results count
  studentResultCountData: null,
  isFetchingStudentResultsCount: false,
  errorFetchingStudentResultsCount: null,
  //copy exam
  isFetchingCopyExam: false,
  errorFetchingCopyExam: null,
  //clone exam
  isFetchingCloneExam: false,
  errorFetchingCloneExam: null,
  //add to exam bank
  isFetchingAddToExamBank: false,
  errorFetchingAddToExamBank: null,

  //exam Search
  examSearchParams: null,

  //question Bank List
  questionBankList: null,
  isFetchingQuestionBankList: true,
  errorFetchingQuestionBankList: null,
  questionBankListOffset: 1,
  questionBankListLoadMore: false,
  //questionList
  questionList: [],
};

const examReducer = (state = INITAIL_STATE, action) => {
  switch (action.type) {
    case ExamActionTypes.SET_QUESTION_LIST:
      let questionsList = [...action.payload];
      questionsList.sort(function (a, b) {
        return a.orders - b.orders;
      });
      console.log({ questionsList });
      questionsList.forEach((element) => {
        console.log({ element });
        element.onlineExamQuestionAnswers.sort(function (a, b) {
          return a.orders - b.orders;
        });
      });
      return {
        ...state,
        questionList: questionsList,
      };
    case ExamActionTypes.ADD_QUESTION:
      let question = action.payload.question;
      let questionIndex = action.payload.index;
      let questions = state.questionList;
      let questionList = [];
      if (questionIndex !== undefined) {
        // if (question.id) {
        //   questionList = [
        //     ...questions.slice(0, questionIndex),
        //     question,
        //     ...questions.slice(questionIndex + 1, questions.length),
        //   ];
        // } else {
        //   questionList = [
        //     ...questions.slice(0, questionIndex),
        //     question,
        //     ...questions.slice(questionIndex + 1, questions.length),
        //     {},
        //   ];
        // }
        questionList = [
          ...questions.slice(0, questionIndex),
          question,
          ...questions.slice(questionIndex + 1, questions.length),
        ];
      } else {
        questionList = [...questions, question];
      }
      return {
        ...state,
        questionList: questionList,
      };

    case ExamActionTypes.EDIT_QUESTION:
      let allQuestions = [];
      allQuestions = [
        ...state.questionList.slice(0, action.payload.index),
        action.payload.question,
        ...state.questionList.slice(
          action.payload.index + 1,
          state.questionList.length
        ),
      ];
      return {
        ...state,
        questionList: allQuestions,
      };
    case ExamActionTypes.DELETE_QUESTION:
      const listQuestion = state.questionList.filter(
        (question, index) => index !== action.payload
      );
      return {
        ...state,
        questionList: listQuestion,
      };

    case ExamActionTypes.SET_QUESTION_BANK_LIST:
      let list = [...action.payload];
      list.forEach((element) => {
        element.onlineExamTemplateQuestionAnswers.sort(function (a, b) {
          return a.orders - b.orders;
        });
      });
      return {
        ...state,
        questionBankList: list,
      };
    case ExamActionTypes.ADD_QUESTION_BANK:
      let questionBank = action.payload.question;
      let questionBankIndex = action.payload.index;
      let questionBanks = state.questionBankList;
      let questionBankList = [];
      if (questionBankIndex !== undefined) {
        // if (question.id) {
        //   questionList = [
        //     ...questions.slice(0, questionIndex),
        //     question,
        //     ...questions.slice(questionIndex + 1, questions.length),
        //   ];
        // } else {
        //   questionList = [
        //     ...questions.slice(0, questionIndex),
        //     question,
        //     ...questions.slice(questionIndex + 1, questions.length),
        //     {},
        //   ];
        // }
        questionBankList = [
          ...questionBanks.slice(0, questionIndex),
          questionBank,
          ...questionBanks.slice(questionIndex + 1, questions.length),
        ];
      } else {
        questionBankList = [questionBank, ...questionBanks];
      }
      return {
        ...state,
        questionBankList: questionBankList,
      };

    case ExamActionTypes.EDIT_QUESTION_BANK:
      let allQuestionBanks = [];
      allQuestionBanks = [
        ...state.questionBankList.slice(0, action.payload.index),
        action.payload.question,
        ...state.questionBankList.slice(
          action.payload.index + 1,
          state.questionBankList.length
        ),
      ];
      return {
        ...state,
        questionBankList: allQuestionBanks,
      };
    case ExamActionTypes.DELETE_QUESTION_BANK:
      const listQuestionBank = state.questionBankList.filter(
        (question, index) => index !== action.payload
      );
      return {
        ...state,
        questionBankList: listQuestionBank,
      };

    default:
      return state;
  }
};

export default examReducer;
